if (!customElements.get('mihm-signed-book')) {
  customElements.define('mihm-signed-book', class extends HTMLElement {
    connectedCallback() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const cart = event.cartData;
        if (cart && typeof cart.item_count === 'number' && Array.isArray(cart.items)) {
          const hasBook = cart.items.some((item) => String(item.product_id) === this.dataset.productId);
          const hasAP = cart.items.some((item) => ['6753612988597', '9580800508134'].includes(String(item.product_id)));
          this.hidden = hasBook || (this.dataset.placement === 'drawer' && !hasAP);
        } else if (String(event.productVariantId) === this.dataset.variantId) {
          this.hidden = true;
          const drawer = document.querySelector('cart-drawer');
          if (drawer && this.contains(drawer.activeElement)) {
            drawer.setActiveElement(document.getElementById('cart-icon-bubble'));
          }
        }
      });
    }
    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }
  });
}
